<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Usuário</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label><span class="required">*</span> Nome:</label>
            <input
              type="text"
              class="form-control"
              name="name"
              v-model="user.name"
              id="name"
            />
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Email</label>
            <input
              type="email"
              class="form-control"
              autocomplete="new-password"
              name="email"
              v-model="user.email"
              id="email"
            />
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Ativo após:</label>
            <input
              type="date"
              class="form-control"
              name="email"
              v-model="user.active_date"
              id="date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label><span class="required">*</span> Senha</label>
            <input
              type="password"
              name="password"
              class="form-control"
              autocomplete="new-password"
              id="password"
              v-model="user.password"
            />
          </div>
          <div class="col-md-2">
            <label><span class="required">*</span> Acesso Rápido</label>
            <input
              type="number"
              class="form-control"
              v-model="user.quick_access"
              v-mask="'####'"
            />
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Permitir Ponto Remoto</label>
            <select class="form-control" v-model="user.remote_check">
              <option value="0">Não</option>
              <option value="1">Sim</option>
            </select>
          </div>
        </div>
        <br />
        <hr class="m-t-md m-b-md" />
        <div class="row">
          <div class="col-md-4">
            <label><span class="required">*</span> Departamento:</label>
            <select class="form-control" v-model="user.department_id">
              <option
                v-for="department in departments"
                :key="department.id"
                :value="department.id"
              >
                {{ department.title }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Cargo</label>
            <select class="form-control" v-model="user.role_id">
              <option v-for="role in roles" :key="role.id" :value="role.id">
                {{ role.title }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Data de Admissão</label>
            <input
              type="date"
              class="form-control"
              v-model="user.admission_date"
              name="admission_date"
              id="admission_date"
            />
          </div>
          <div class="col-md-4 mt-2">
            <label>Data de Demissão</label>
            <input
              type="date"
              class="form-control"
              v-model="user.demission_date"
              name="admission_date"
              id="admission_date"
            />
          </div>
           <div class="col-md-4 mt-2">
            <label>Valor do Vale Transporte</label>
            <input
              type="text"
              class="form-control"
              v-model="user.transport_value"
              v-money="money"
              name="transport_value"
              id="transport_value"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label><span class="required">*</span> CPF</label>
            <input
              type="text"
              class="form-control"
              v-mask="'###.###.###-##'"
              v-model="user.cpf"
              name="cpf"
              id="cpf"
              placeholder="000.000.000-00"
            />
          </div>
          <div class="col-md-4">
            <label>Carteira de trabalho:</label>
            <input
              type="text"
              class="form-control"
              v-mask="'######'"
              v-model="user.ctps"
              name="ctps"
              id="ctps"
              placeholder="000000"
            />
          </div>
          <div class="col-md-4">
            <label>PIS/PASEP</label>
            <input
              type="text"
              class="form-control"
              v-mask="'###.#####.##-#'"
              v-model="user.pis_pasep"
              name="pis_pasep"
              id="pis_pasep"
              placeholder="00.00000.00-0"
            />
          </div>
        </div>
        <hr class="m-t-md m-b-md" />

        <div class="row">
          <div class="col-md-12">
            <input type="file" name="photo" id="photo" />
          </div>
        </div>

        <hr />

        <div class="block text-right">
          <router-link to="/users" class="btn btn-info">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-success" @click="save">
            Salvar <i class="fa fa-save"></i>
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import {VMoney} from 'v-money'

export default {
  directives: { mask, money: VMoney },
  data() {
    return {
      user: {
        name: "",
        email: "",
        password: "",
        department_id: "",
        role_id: "",
        admission_date: "",
        demission_date: "",
        cpf: "",
        ctps: "",
        pis_pasep: "",
        quick_access: "",
        remote_check: "0",
      },
      departments: [],
      roles: [],
      money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: true /* doesn't work with directive */
        }
    };
  },
  methods: {
    save: function () {
      const self = this;

      if (self.user.id) return self.edit();

      const api = this.$store.state.api + "users";

      let fd = self.makeFormData();

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Usuário cadastrado com sucesso`, "success");
          this.$router.push("/users");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    edit: function () {
      const self = this;
      const api = self.$store.state.api + "users/" + self.user.id;

      let fd = self.makeFormData();

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Cadastro atualizado com sucesso`,
            "success"
          );
          this.$router.push("/users");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    makeFormData: function () {
      const self = this;

      let fd = new FormData();

      let photo = document.getElementById("photo").files[0];
      if (photo) {
        fd.append("photo", photo);
      }

      fd.append("name", self.user.name);
      fd.append("email", self.user.email);
      fd.append("remote_check", self.user.remote_check);
      fd.append(
        "department_id",
        self.user.department_id ? self.user.department_id : ""
      );
      fd.append("role_id", self.user.role_id ? self.user.role_id : "");
      fd.append(
        "admission_date",
        self.user.admission_date ? self.user.admission_date : ""
      );
      fd.append(
        "demission_date",
        self.user.demission_date ? self.user.demission_date : ""
      );
      fd.append("transport_value", self.user.transport_value.replace(".", "").replace(",", "."));
      fd.append("cpf", self.user.cpf);
      fd.append("ctps", self.user.ctps);
      fd.append("pis_pasep", self.user.pis_pasep);
      fd.append("active_date", self.user.active_date);
      if (self.user.password) {
        fd.append("password", self.user.password);
      }
      fd.append("quick_access", self.user.quick_access);

      if (self.user.id) {
        fd.append("id", self.user.id);
        fd.append("active_date", self.user.active_date);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    getUser: function (id) {
      let self = this;
      let api = self.$store.state.api + "users/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.user = response.data.data[0];
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getDepartments: function () {
      let self = this;
      let api = self.$store.state.api + "departments/";

      self.$http
        .get(api)
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getRoles: function () {
      let self = this;
      let api = self.$store.state.api + "roles/";

      self.$http
        .get(api)
        .then((response) => {
          self.roles = response.data.data;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getDepartments();
    self.getRoles();

    let id = self.$route.params.id;
    if (id) {
      self.getUser(id);
    }

    self.getDepartments();
    self.getRoles();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/User.vue